import * as React from "react";
import {Component, Fragment, ReactElement} from "react";

import { connect } from "react-redux";
import ApiService from "../../ApiService";
import DispatchProps from "../../../utils/DispatchProps";
import PageTitle from "../../PageTitle";
import {IRootState} from "../../../store";
import {DurableFunctionInstance} from "../../../models/DurableFunctionInstance";
import LoadingPage from "../../LoadingPage";
import {CommandBarButton, MessageBar, MessageBarType} from "office-ui-fabric-react";
import HelpBox from "../admin/HelpBox";
import Table, {TableColumn} from "../../Table";
import MailroomDurableFunctionInstanceList from "../../mailroom/MailroomDurableFunctionInstanceList";
import TableCell from "../../TableCell";
import MailroomDurableFunctionInstanceStatus from "../../mailroom/MailroomDurableFunctionInstanceStatus";
import DurableFunctionInstanceDuration from "../../DurableFunctionInstanceDuration";

interface FreshdeskSyncPageProps {
    apiService: ApiService;
}

interface FreshdeskSyncPageState {
    availabilityResult?: {available: boolean},
    orchestration?: DurableFunctionInstance | null
}

class FreshdeskSyncPage extends Component<FreshdeskSyncPageProps & DispatchProps, FreshdeskSyncPageState> {

    constructor(props: FreshdeskSyncPageProps & DispatchProps) {
        super(props);

        this.state = {
            availabilityResult: undefined,
            orchestration: undefined
        };
    }
    async componentDidMount(): Promise<void> {

        const availabilityResult = await this.props.apiService.getFreshdeskAvailability();
        this.setState({
            availabilityResult
        })
        
        if(availabilityResult.available)
        {
            await this.loadOrchestration();
        }
        
    }

    private loadOrchestration = async () =>
    {
        const orchestration = await this.props.apiService.getFreshdeskSyncOrchestration();
        this.setState({
            orchestration
        });
    }
    
    async componentDidUpdate(prevProps: Readonly<FreshdeskSyncPageProps & DispatchProps>, prevState: any): Promise<void> {

    }
    
    private buildOrchestrationTable(): JSX.Element | null
    {
        if(this.state.orchestration === undefined)
        {
            return null;
        }


        let cellForColumn = (item: DurableFunctionInstance, column: TableColumn, columnIndex: number): ReactElement<TableCell> | undefined => {
            switch (column.propertyPath) {
    
                case "duration":
                    return (
                        <DurableFunctionInstanceDuration durableFunctionInstance={item} flex={column.flex} />
                    );
    
                case "status":
                    return (
                        <MailroomDurableFunctionInstanceStatus durableFunctionInstance={item} flex={column.flex} />
                    );
            }
        };        
        
        return (
            <Table title={"FreshdeskSyncOrchestration"} items={[this.state.orchestration!]} columns={MailroomDurableFunctionInstanceList.genericColumns} cellForColumn={cellForColumn}>
                
                <CommandBarButton
                    iconProps={{ iconName: "cancel" }}
                    text="Stop Sync Orchestration"
                    onClick={async () => {
                        await this.props.apiService.terminateFreshdeskSyncOrchestration();
                        await this.loadOrchestration();
                    }}
                />
                
                <CommandBarButton
                    iconProps={{ iconName: "play" }}
                    text="Start Sync Orchestration"
                    onClick={async () => {
                        await this.props.apiService.startFreshdeskSyncOrchestration();
                        await this.loadOrchestration();
                    }}
                />
            </Table>
        )
    }
    
    public render(): JSX.Element {

        if(this.state.availabilityResult === undefined)
        {
            return <LoadingPage/>;
        }
        
        let messageBar: JSX.Element | null = null; 
        if(this.state.availabilityResult.available === false)
        {
            messageBar = (
                <MessageBar messageBarType={MessageBarType.warning} >
                    Freshdesk integration is not available on this environment.
                </MessageBar>
            ); 
        }
        
        return (
            <Fragment>
                <PageTitle title={`FreshDesk Sync`} />
                
                {messageBar}

                <HelpBox
                    TitleText="Freshdesk Sync"
                    HelpBoxText="Companies in Freshdesk with the custom field unique_id set to tenantId-schoolCode will be synced to the corresponding school."
                    Icon={'Sync'}
                />

                {this.buildOrchestrationTable()}
                
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: any): FreshdeskSyncPageProps => {
        return {
            apiService: state.auth.apiService,
        };

    }
)(FreshdeskSyncPage)